import { FC, useEffect } from 'react';
import { useCampaignStore } from 'store/campaignStore';
import { useProductStore } from 'store/productStore';
import { RsButton, RsButtonSize } from 'components/Rsuite/Button';
import { Form } from 'rsuite';
import IconWithTooltip from 'components/IconWithTooltip/IconWithTooltip';
import { faPencilAlt } from '@fortawesome/free-solid-svg-icons';
import i18n from 'i18n';
import styles from 'containers/RtbCampaigns/RtbCampaignSinglePage/Components/Common/manualSelection.module.scss';

interface ManualSelectionProps {
  availableProducts: number;
  errorMessage: { products?: string; limitations?: string } | undefined;
  hideTitle?: boolean;
  customButtom?: React.ReactNode;
}

export const ManualSelection: FC<ManualSelectionProps> = ({
  availableProducts,
  errorMessage,
  hideTitle,
  customButtom,
}) => {
  const { openProductManager } = useCampaignStore();
  const { selectedProducts: products } = useProductStore();
  const error = errorMessage?.products
    ? errorMessage.products
    : errorMessage?.limitations;

  const handleOpenDrawer = () => {
    openProductManager(true);
  };

  return (
    <div className='flex h-[42px] flex-col gap-[8px]'>
      <div className='flex items-center gap-[8px]'>
        {!hideTitle && <div>商品選擇</div>}
        <div className='rs-form-control-wrapper'>
          <RsButton size={RsButtonSize.LARGE} onClick={handleOpenDrawer}>
            {`已選商品(${products.length}/${availableProducts})`}{' '}
            <IconWithTooltip
              placement='right'
              className={styles.productEditBtn}
              icon={faPencilAlt}
              tooltipProps={{
                id: `campaignListCreativeEditHint`,
                tooltip: i18n.t<string>('campaignList.labels.creativeEditHint'),
              }}
            />
          </RsButton>
          <Form.ErrorMessage show={error !== undefined} placement='topEnd'>
            {error}
          </Form.ErrorMessage>
        </div>
      </div>
      {customButtom && <Form.HelpText>{customButtom}</Form.HelpText>}
    </div>
  );
};
